<template>
  <div id="a-webgl"></div>
</template>

<script>
import Webgl from './webgl';

let webgl;

export default {
  mounted() {
    webgl = new Webgl();
    webgl.init();
  },
};
</script>
